import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { importIcon } from '@y42/icons';
import { ImportWriteType } from '@y42/json-schema';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'y42-data-test-import-type-cell-renderer',
  templateUrl: './data-test-import-type-cell-renderer.component.html',
  styleUrls: ['./data-test-import-type-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataTestImportTypeCellRendererComponent implements ICellRendererAngularComp {
  private readonly params$$ = new BehaviorSubject<ICellRendererParams<unknown, ImportWriteType> | null>(null);

  readonly importIcon = importIcon;

  readonly state = connectState(this, {
    showValue: this.params$$.pipe(map((params) => params?.node.group === true)),
    isTruncate: this.params$$.pipe(map((params) => params?.value === ImportWriteType.Truncate)),
    isAppend: this.params$$.pipe(map((params) => params?.value === ImportWriteType.Append)),
  });

  agInit(params: ICellRendererParams<unknown, ImportWriteType>): void {
    this.params$$.next(params);
  }

  refresh(params: ICellRendererParams<unknown, ImportWriteType>): boolean {
    this.params$$.next(params);
    return true;
  }
}
